import { GpPFileUpload } from '@/app/editor/iframe/atom/module/GpPFileUpload';
import { GpPSwatches } from '@/app/editor/iframe/atom/module/GpPSwatches';
import { GpRelatedProducts } from './module/GpRelatedProducts';
import { GpFrequentlyBoughtTogether } from '@/app/editor/iframe/atom/third-party/GpFrequentlyBoughtTogether';
import { checkKeyValid } from '@/app/utils/checkRoleApply';
import type { TypeSettings } from '@/app/editor/iframe/atom/Atom.model';
import { GpButton } from '@/app/editor/iframe/atom/element/GpButton';
import { GpImage } from '@/app/editor/iframe/atom/element/GpImage';
import { GpHeading } from '@/app/editor/iframe/atom/element/GpHeading';
import { GpTextBlock } from '@/app/editor/iframe/atom/element/GpTextBlock';
import { GpIcon } from '@/app/editor/iframe/atom/element/GpIcon';
import { GpTextField } from '@/app/editor/iframe/atom/element/GpTextField';
import { GpEmailField } from '@/app/editor/iframe/atom/element/GpEmailField';
import { GpTextarea } from '@/app/editor/iframe/atom/element/GpTextarea';
import { GpDropdown } from '@/app/editor/iframe/atom/element/GpDropdown';
import { GpCheckbox } from '@/app/editor/iframe/atom/element/GpCheckbox';
import { GpSubmitButton } from '@/app/editor/iframe/atom/element/GpSubmitButton';
import { GpSeparator } from '@/app/editor/iframe/atom/element/GpSeparator';
import { GpHeroBanner } from '@/app/editor/iframe/atom/module/GpHeroBanner';
import { GpAliReviews } from '@/app/editor/iframe/atom/third-party/GpAliReviews';
import { GpLaiReviews } from '@/app/editor/iframe/atom/third-party/GpLaiReviews';
import { GpUltimateSalesBoost } from '@/app/editor/iframe/atom/third-party/GpUltimateSalesBoost';
import { GpPickyStory } from '@/app/editor/iframe/atom/third-party/GpPickyStory';
import { GpProductList } from '@/app/editor/iframe/atom/module/GpProductList';
import { GpViewMore } from '@/app/editor/iframe/atom/module/GpViewMore';
import { GpWideBundle } from '@/app/editor/iframe/atom/third-party/GpWideBundle';
import { GpSmartInstantSearch } from '@/app/editor/iframe/atom/third-party/GpSmartInstantSearch';
import { GpProductPersonalizer } from '@/app/editor/iframe/atom/third-party/GpProductPersonalizer';
import { GpKlaviyoSignupForm } from '@/app/editor/iframe/atom/third-party/GpKlaviyoSignupForm';
import { GpLooxCarousel } from '@/app/editor/iframe/atom/third-party/GpLooxCarousel';
import { GpOpinewProductReviews } from '@/app/editor/iframe/atom/third-party/GpOpinewProductReviews';
import { GpRivyoProductReviews } from '@/app/editor/iframe/atom/third-party/GpRivyoProductReviews';
import { GpStampedReview } from '@/app/editor/iframe/atom/third-party/GpStampedReview';
import { GpTobiOptInCheckbox } from '@/app/editor/iframe/atom/third-party/GpTobiOptInCheckbox';
import { GpFirepushOptInsEmbedButton } from './third-party/GpFirepushOptInsEmbedButton';
import { GpKaching } from '@/app/editor/iframe/atom/third-party/GpKaching';
import { GpRyviuProductReviews } from '@/app/editor/iframe/atom/third-party/GpRyviuProductReviews';
import { GpProductFilterSearch } from '@/app/editor/iframe/atom/third-party/GpProductFilterSearch';
import { GpCrossSell } from '@/app/editor/iframe/atom/third-party/GpCrossSell';
import { GpJudgeReviews } from '@/app/editor/iframe/atom/third-party/GpJudgeReviews';
import { GpAfterpay } from '@/app/editor/iframe/atom/third-party/GpAfterpay';
import { GpBoldProductOptions } from '@/app/editor/iframe/atom/third-party/GpBoldProductOptions';
import { GpFeraReviewsFeatured } from '@/app/editor/iframe/atom/third-party/GpFeraReviewsFeatured';
import { GpVitals } from '@/app/editor/iframe/atom/third-party/GpVitals';
import { GpSealSubscriptions } from '@/app/editor/iframe/atom/third-party/GpSealSubscriptions';
import { GpAppstleSubscriptions } from '@/app/editor/iframe/atom/third-party/GpAppstleSubscriptions';
import { GpParcelPanel } from '@/app/editor/iframe/atom/third-party/GpParcelPanel';

import { GpBoldSubscriptions } from '@/app/editor/iframe/atom/third-party/GpBoldSubscriptions';
import { GpYotpoCustomPages } from '@/app/editor/iframe/atom/third-party/GpYotpoCustomPages';
import { GpYotpoProductCollectionPage } from '@/app/editor/iframe/atom/third-party/GpYotpoProductCollectionPage';
import { GpTrustMe } from '@/app/editor/iframe/atom/third-party/GpTrustMe';
import { GpInstafeed } from '@/app/editor/iframe/atom/third-party/GpInstafeed';

import { GpProductReviews } from '@/app/editor/iframe/atom/third-party/GpProductReviews';
import { GpWiserPersonalizedRecommendations } from '@/app/editor/iframe/atom/third-party/GpWiserPersonalizedRecommendations';
import { GpInfiniteOptions } from '@/app/editor/iframe/atom/third-party/GpInfiniteOptions';
import { GpJudgeReviewsCarousel } from '@/app/editor/iframe/atom/third-party/GpJudgeReviewsCarousel';
import { GpGrowave } from '@/app/editor/iframe/atom/third-party/GpGrowave';
import { GpLooxProductPageStars } from '@/app/editor/iframe/atom/third-party/GpLooxProductPageStars';
import { GpParallax } from '@/app/editor/iframe/atom/module/GpParallax';
import { GpPCartButton } from './module/GpPCartButton';
import { GpPStockCounter } from './module/GpPStockCounter';
import { GpProductImage } from '@/app/editor/iframe/atom/module/GpProductImage';
import { GpPaginator } from './module/GpPaginator';
import { GpProduct } from '@/app/editor/iframe/atom/module/GpProduct';
import { GpPVariants } from '@/app/editor/iframe/atom/module/GpPVariants';
import storeX from '@/store';
import { isLandingPage } from '@/modules/gem-meter';
import { GpTrustoo } from '@/app/editor/iframe/atom/third-party/GpTrustoo';

// import { GpProduct } from "@/app/editor/iframe/atom/module/GpProduct";
// import { GpTabs } from "@/app/editor/iframe/atom/module/GpTabs";
// import STORE from  "@/app/store/store";
// import { getShopNameApply } from "@/app/editor/iframe/atom/atom-spec/atom.funtions.ts";

export default {
  /**
   * Init Atom when using Utilities Classes
   * @param $els DOM ($atom)
   * @param options atom Data setting
   */
  Init($els: JQuery, options?: TypeSettings) {
    if (!$els || !$els.length) {
      return;
    }

    // ===== GemMeter Feature ===== //
    const __countElement = () => {
      if ((window as any).__countElement === 0) {
        storeX.state.editor.loadFinishALLMER = true;
      } else {
        (window as any).__countElement = (window as any).__countElement - 1;
      }
    };

    if (isLandingPage()) {
      __countElement();
    }
    // =========================== //

    // let isTest = false;
    // const urlParams = new URLSearchParams(window.location.search);
    // isTest = urlParams.get("test") == "true" ? true : false;
    // if (isTest) {
    //   console.log("mode: Test");
    // } else {
    //   console.log("mode: Normal");
    // }
    $els.each((_index, el) => {
      const $el = jQuery(el);
      const key = $el.attr('data-key') || '';
      const snippetHtml = options?.snippet ? options.snippet.outterHtml : undefined;

      // Assign to new option and change snippet to string type to fixed memory leak
      const cOption = Object.assign({}, options);
      cOption.snippet = snippetHtml;

      switch (key) {
        case 'button': {
          if (checkKeyValid('atomButton')) {
            const classAtom = new GpButton($el[0], options);
            $el.data('gfelement', classAtom);
          } else {
            ($el as any).gfElement(cOption);
          }
          break;
        }
        case 'image': {
          if (checkKeyValid('atomImage')) {
            const classAtom = new GpImage($el[0], options);
            $el.data('gfelement', classAtom);
          } else {
            ($el as any).gfElement(cOption);
          }
          break;
        }
        case 'heading': {
          if (checkKeyValid('atomHeading')) {
            const classAtom = new GpHeading($el[0], options);
            $el.data('gfelement', classAtom);
          } else {
            ($el as any).gfElement(cOption);
          }
          break;
        }
        case 'text-block': {
          if (checkKeyValid('atomTextBlock')) {
            const classAtom = new GpTextBlock($el[0], options);
            $el.data('gfelement', classAtom);
          } else {
            ($el as any).gfElement(cOption);
          }
          break;
        }
        case 'icon': {
          if (checkKeyValid('atomIcon')) {
            const classAtom = new GpIcon($el[0], options);
            $el.data('gfelement', classAtom);
          } else {
            ($el as any).gfElement(cOption);
          }
          break;
        }
        case 'text-field': {
          if (checkKeyValid('atomTextField')) {
            const classAtom = new GpTextField($el[0], options);
            $el.data('gfelement', classAtom);
          } else {
            ($el as any).gfElement(cOption);
          }
          break;
        }
        case 'email-field': {
          if (checkKeyValid('atomEmailField')) {
            const classAtom = new GpEmailField($el[0], options);
            $el.data('gfelement', classAtom);
          } else {
            ($el as any).gfElement(cOption);
          }
          break;
        }
        case 'text-area': {
          if (checkKeyValid('atomTextArea')) {
            const classAtom = new GpTextarea($el[0], options);
            $el.data('gfelement', classAtom);
          } else {
            ($el as any).gfElement(cOption);
          }
          break;
        }
        case 'dropdown': {
          if (checkKeyValid('atomDropdown')) {
            const classAtom = new GpDropdown($el[0], options);
            $el.data('gfelement', classAtom);
          } else {
            ($el as any).gfElement(cOption);
          }
          break;
        }
        case 'checkbox': {
          if (checkKeyValid('atomCheckbox')) {
            const classAtom = new GpCheckbox($el[0], options);
            $el.data('gfelement', classAtom);
          } else {
            ($el as any).gfElement(cOption);
          }
          break;
        }
        case 'submit-button': {
          if (checkKeyValid('atomSubmitButton')) {
            const classAtom = new GpSubmitButton($el[0], options);
            $el.data('gfelement', classAtom);
          } else {
            ($el as any).gfElement(cOption);
          }
          break;
        }
        case 'separator': {
          if (checkKeyValid('atomSeparator')) {
            const classAtom = new GpSeparator($el[0], options);
            $el.data('gfelement', classAtom);
          } else {
            ($el as any).gfElement(cOption);
          }
          break;
        }
        case 'related-products': {
          if (checkKeyValid('atomRelatedProducts')) {
            const classAtom = new GpRelatedProducts($el[0], options);
            $el.data('gfelement', classAtom);
          } else {
            ($el as any).gfModule(cOption);
          }
          break;
        }
        case 'hero-banner': {
          if (checkKeyValid('atomHeroBanner')) {
            const classAtom = new GpHeroBanner($el[0], options);
            $el.data('gfmodule', classAtom);
          } else {
            ($el as any).gfModule(cOption);
          }
          break;
        }
        case 'product-list': {
          if (checkKeyValid('atomProductList')) {
            const classAtom = new GpProductList($el[0], options);
            $el.data('gfmodule', classAtom);
          } else {
            ($el as any).gfModule(cOption);
          }
          break;
        }
        case 'parallax': {
          if (checkKeyValid('atomParallax')) {
            const classAtom = new GpParallax($el[0], options);
            $el.data('gfmodule', classAtom);
          } else {
            ($el as any).gfModule(cOption);
          }
          break;
        }
        case 'loox': {
          if (checkKeyValid('atomLooxProductPageStars')) {
            const classAtom = new GpLooxProductPageStars($el[0], options);
            $el.data('gfmodule', classAtom);
          } else {
            ($el as any).gfModule(cOption);
          }
          break;
        }
        case 'product-personalizer': {
          if (checkKeyValid('atomProductPersonalizer')) {
            const classAtom = new GpProductPersonalizer($el[0], options);
            $el.data('gfmodule', classAtom);
          } else {
            ($el as any).gfModule(cOption);
          }
          break;
        }
        case 'frequently-bought-together': {
          if (checkKeyValid('atomFrequentlyBoughtTogether')) {
            const classAtom = new GpFrequentlyBoughtTogether($el[0], options);
            $el.data('gfmodule', classAtom);
          } else {
            ($el as any).gfModule(cOption);
          }
          break;
        }
        case 'stamped-product-reviews': {
          const classAtom = new GpStampedReview($el[0], options);
          $el.data('gfmodule', classAtom);
          break;
        }
        case 'smart-search-instant-search': {
          if (checkKeyValid('atomSmartInstantSearch')) {
            const classAtom = new GpSmartInstantSearch($el[0], options);
            $el.data('gfmodule', classAtom);
          } else {
            ($el as any).gfModule(cOption);
          }
          break;
        }
        case 'yotpo-featured': {
          if (checkKeyValid('atomYotpoCustomPages')) {
            const classAtom = new GpYotpoCustomPages($el[0], options);
            $el.data('gfmodule', classAtom);
          } else {
            ($el as any).gfModule(cOption);
          }
          break;
        }
        case 'instafeed': {
          if (checkKeyValid('atomInstafeed')) {
            const classAtom = new GpInstafeed($el[0], options);
            $el.data('gfmodule', classAtom);
          } else {
            ($el as any).gfModule(cOption);
          }
          break;
        }
        case 'ali-reviews': {
          if (checkKeyValid('atomAliReviews')) {
            const classAtom = new GpAliReviews($el[0], options);
            $el.data('gfmodule', classAtom);
          } else {
            ($el as any).gfModule(cOption);
          }
          break;
        }
        case 'opinew-product-reviews': {
          const classAtom = new GpOpinewProductReviews($el[0], options);
          $el.data('gfmodule', classAtom);
          break;
        }
        case 'lai-aliexpress-reviews': {
          if (checkKeyValid('atomLaiReviews')) {
            const classAtom = new GpLaiReviews($el[0], options);
            $el.data('gfmodule', classAtom);
          } else {
            ($el as any).gfModule(cOption);
          }
          break;
        }
        case 'yotpo-reviews': {
          if (checkKeyValid('atomYotpoProductCollectionPage')) {
            const classAtom = new GpYotpoProductCollectionPage($el[0], options);
            $el.data('gfmodule', classAtom);
          } else {
            ($el as any).gfModule(cOption);
          }
          break;
        }
        case 'ultimate-sales-boost': {
          if (checkKeyValid('atomUSB')) {
            const classAtom = new GpUltimateSalesBoost($el[0], options);
            $el.data('gfmodule', classAtom);
          } else {
            ($el as any).gfModule(cOption);
          }
          break;
        }
        case 'tobi-sms-marketing-automation': {
          if (checkKeyValid('atomTobiOptInCheckbox')) {
            const classAtom = new GpTobiOptInCheckbox($el[0], options);
            $el.data('gfmodule', classAtom);
          } else {
            ($el as any).gfModule(cOption);
          }
          break;
        }
        case 'picky-story': {
          if (checkKeyValid('atomPickyStory')) {
            const classAtom = new GpPickyStory($el[0], options);
            $el.data('gfmodule', classAtom);
          } else {
            ($el as any).gfModule(cOption);
          }
          break;
        }
        case 'loox-reviews-carousel': {
          if (checkKeyValid('atomLooxCarousel')) {
            const classAtom = new GpLooxCarousel($el[0], options);
            $el.data('gfmodule', classAtom);
          } else {
            ($el as any).gfModule(cOption);
          }
          break;
        }
        case 'klaviyo-signup-form': {
          if (checkKeyValid('atomKlaviyoSignupForm')) {
            const classAtom = new GpKlaviyoSignupForm($el[0], options);
            $el.data('gfmodule', classAtom);
          } else {
            ($el as any).gfModule(cOption);
          }
          break;
        }
        case 'product-reviews': {
          if (checkKeyValid('atomProductReviews')) {
            const classAtom = new GpProductReviews($el[0], options);
            $el.data('gfmodule', classAtom);
          } else {
            ($el as any).gfModule(cOption);
          }
          break;
        }
        case 'afterpay': {
          if (checkKeyValid('atomAfterpay')) {
            const classAtom = new GpAfterpay($el[0], options);
            $el.data('gfmodule', classAtom);
          } else {
            ($el as any).gfModule(cOption);
          }
          break;
        }
        case 'wiser-personalized-recommendations-v2': {
          const classAtom = new GpWiserPersonalizedRecommendations($el[0], options);
          $el.data('gfmodule', classAtom);
          break;
        }
        case 'rivyo-product-reviews': {
          const classAtom = new GpRivyoProductReviews($el[0], options);
          $el.data('gfmodule', classAtom);
          break;
        }
        case 'infinite-options': {
          const classAtom = new GpInfiniteOptions($el[0], options);
          $el.data('gfmodule', classAtom);
          break;
        }
        case 'widebundle': {
          if (checkKeyValid('atomWideBundle')) {
            const classAtom = new GpWideBundle($el[0], options);
            $el.data('gfmodule', classAtom);
          } else {
            ($el as any).gfModule(cOption);
          }
          break;
        }
        case 'judge-reviews-carousel': {
          if (checkKeyValid('atomJudgeReviewsCarousel')) {
            const classAtom = new GpJudgeReviewsCarousel($el[0], options);
            $el.data('gfmodule', classAtom);
          } else {
            ($el as any).gfModule(cOption);
          }
          break;
        }
        case 'trust-me': {
          const classAtom = new GpTrustMe($el[0], options);
          $el.data('gfmodule', classAtom);
          break;
        }
        case 'judge-reviews': {
          if (checkKeyValid('atomJudgeReviews')) {
            const classAtom = new GpJudgeReviews($el[0], options);
            $el.data('gfmodule', classAtom);
          } else {
            ($el as any).gfModule(cOption);
          }
          break;
        }
        case 'firepush-sms-email-web-push': {
          if (checkKeyValid('atomFirepushOptInsEmbedButton')) {
            const classAtom = new GpFirepushOptInsEmbedButton($el[0], options);
            $el.data('gfmodule', classAtom);
          } else {
            ($el as any).gfModule(cOption);
          }
          break;
        }
        case 'growave': {
          const classAtom = new GpGrowave($el[0], options);
          $el.data('gfmodule', classAtom);
          break;
        }
        case 'p-variants': {
          if (checkKeyValid('atomVariants')) {
            const classAtom = new GpPVariants($el[0], options);
            $el.data('gfmodule', classAtom);
          } else {
            ($el as any).gfModule(cOption);
          }
          break;
        }
        case 'ryviu-product-reviews': {
          const classAtom = new GpRyviuProductReviews($el[0], options);
          $el.data('gfmodule', classAtom);
          break;
        }
        case 'product-filter-search': {
          if (checkKeyValid('atomProductFilterSearch')) {
            const classAtom = new GpProductFilterSearch($el[0], options);
            $el.data('gfmodule', classAtom);
          } else {
            ($el as any).gfModule(cOption);
          }
          break;
        }
        case 'cross-sell-cart-upsell': {
          if (checkKeyValid('atomCrossSell')) {
            const classAtom = new GpCrossSell($el[0], options);
            $el.data('gfmodule', classAtom);
          } else {
            ($el as any).gfModule(cOption);
          }
          break;
        }
        case 'trustoo': {
          const classAtom = new GpTrustoo($el[0], options);
          $el.data('gfmodule', classAtom);
          break;
        }
        case 'bold-product-options': {
          if (checkKeyValid('atomBoldProductOptions')) {
            const classAtom = new GpBoldProductOptions($el[0], options);
            $el.data('gfmodule', classAtom);
          } else {
            ($el as any).gfModule(cOption);
          }
          break;
        }
        case 'fera-reviews': {
          const classAtom = new GpFeraReviewsFeatured($el[0], options);
          $el.data('gfmodule', classAtom);
          break;
        }
        case 'vitals': {
          const classAtom = new GpVitals($el[0], options);
          $el.data('gfmodule', classAtom);
          break;
        }
        case 'seal-subscriptions': {
          const classAtom = new GpSealSubscriptions($el[0], options);
          $el.data('gfmodule', classAtom);
          break;
        }
        case 'appstle-subscriptions': {
          const classAtom = new GpAppstleSubscriptions($el[0], options);
          $el.data('gfmodule', classAtom);
          break;
        }
        case 'parcel-panel': {
          const classAtom = new GpParcelPanel($el[0], options);
          $el.data('gfmodule', classAtom);
          break;
        }
        case 'bold-subscriptions': {
          const classAtom = new GpBoldSubscriptions($el[0], options);
          $el.data('gfmodule', classAtom);
          break;
        }
        case 'kaching': {
          const classAtom = new GpKaching($el[0], options);
          $el.data('gfmodule', classAtom);
          break;
        }
        case 'p-file-upload': {
          if (checkKeyValid('atomPFileUpload')) {
            const classAtom = new GpPFileUpload($el[0], options);
            $el.data('gfmodule', classAtom);
          } else {
            ($el as any).gfModule(cOption);
          }
          break;
        }
        case 'p-swatches': {
          if (checkKeyValid('atomPSwatches')) {
            const classAtom = new GpPSwatches($el[0], options);
            $el.data('gfmodule', classAtom);
          } else {
            ($el as any).gfModule(cOption);
          }
          break;
        }
        case 'p-view-more': {
          if (checkKeyValid('atomViewMore')) {
            const classAtom = new GpViewMore($el[0], options);
            $el.data('gfmodule', classAtom);
          } else {
            ($el as any).gfModule(cOption);
          }
          break;
        }
        case 'p-cart-button': {
          if (checkKeyValid('atomPCartButton')) {
            const classAtom = new GpPCartButton($el[0], options);
            $el.data('gfmodule', classAtom);
          } else {
            ($el as any).gfModule(cOption);
          }

          break;
        }
        case 'p-stock-counter': {
          if (checkKeyValid('atomPStockCounter')) {
            const classAtom = new GpPStockCounter($el[0], options);
            $el.data('gfmodule', classAtom);
          } else {
            ($el as any).gfModule(cOption);
          }

          break;
        }
        case 'product': {
          if (checkKeyValid('atomProduct')) {
            const classAtom = new GpProduct($el[0], options);
            $el.data('gfmodule', classAtom);
          } else {
            ($el as any).gfModule(cOption);
          }

          break;
        }
        case 'p-image': {
          if (checkKeyValid('atomProductImage')) {
            const classAtom = new GpProductImage($el[0], options);
            $el.data('gfmodule', classAtom);
          } else {
            ($el as any).gfModule(cOption);
          }

          break;
        }

        case 'paginator': {
          if (checkKeyValid('atomPaginator')) {
            const classAtom = new GpPaginator($el[0], options);
            $el.data('gfmodule', classAtom);
          } else {
            ($el as any).gfModule(cOption);
          }
          break;
        }

        default: {
          let elementType = '';
          if ($el.hasClass('gf_row')) {
            elementType = '#r-';
          } else if ($el.hasClass('module-wrap')) {
            elementType = '#m-';
          } else if ($el.hasClass('element-wrap')) {
            elementType = '#e-';
          }
          if (options && options.snippet) {
            const $snippet = jQuery(options.snippet);
            const type = $snippet.attr('data-type');
            switch (type) {
              case 'module':
                elementType = '#m-';
                break;
              case 'element':
                elementType = '#e-';
                break;
              case 'row':
                elementType = '#r-';
                break;
            }
          }
          switch (elementType) {
            case '#m-': {
              ($el as any).gfModule(cOption);
              break;
            }
            case '#e-': {
              ($el as any).gfElement(cOption);
              break;
            }
            case '#r-': {
              ($el as any).gfRow(cOption);
              break;
            }
          }
          break;
        }
      }
    });
  },
};
